import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { IconBurgerMenu, IconHelpCircle, IconSfx, IconSettings } from '@sfx/icons';
import { truncate } from '../../Business/utils/utils';
import { fetchSolutions, getSFxSolutions, setTabIcon } from '../../Business/utils/checkSFxRoleAuth';
import { initHost } from '../../Business/api';

import defaultLogoSrc from './images/Sfx.svg';
var prefix = 'sfx-react-ui';

var Header = /*#__PURE__*/function (_Component) {
  _inherits(Header, _Component);

  var _super = _createSuper(Header);

  function Header() {
    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      openSolutionBar: false,
      orgLogoUrl: '',
      count: 0,
      orgName: ''
    });

    _defineProperty(_assertThisInitialized(_this), "changeFavicon", function (currentSolutionId) {
      var solutions = getSFxSolutions();

      if (!solutions.length) {
        initHost();
        fetchSolutions().then(function (solutions) {
          setTabIcon(solutions, currentSolutionId);
        });
      } else {
        setTabIcon(solutions, currentSolutionId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "transformUrl", function (url) {
      // Pick 8 characters randomly and append them to passed in url
      var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var str = '';

      for (var i = 0; i < 8; i++) {
        str += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      return url ? "".concat(url, "?t=").concat(str) : null;
    });

    _defineProperty(_assertThisInitialized(_this), "triggerSolutionBar", function () {
      _this.setState({
        openSolutionBar: !_this.state.openSolutionBar
      });
    });

    _defineProperty(_assertThisInitialized(_this), "throwError", function () {
      var _this$props = _this.props,
          isShowSolutionBar = _this$props.isShowSolutionBar,
          solutionBar = _this$props.solutionBar;

      if (solutionBar && !isShowSolutionBar) {
        throw Error('Parameter Error:You must set the parameter "isShowSolutionBar" to true');
      }
    });

    return _this;
  }

  _createClass(Header, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.loggedIn == true && this.state.count === 0) {
        var userObj = localStorage.getItem("OIDCUSER");
        var user = userObj && JSON.parse(userObj);

        if (user && user.profile && !this.state.orgLogoUrl) {
          this.setState({
            orgLogoUrl: this.transformUrl(user.profile.OrgLogoUrl),
            orgName: user.profile.OrgName
          });
          this.changeFavicon(user.profile.SolutionId);
        }

        this.setState({
          count: 1
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          theme = _this$props2.theme,
          logo = _this$props2.logo,
          loggedIn = _this$props2.loggedIn,
          orgName = _this$props2.orgName,
          shortTitle = _this$props2.shortTitle,
          isShowShortTitleLogo = _this$props2.isShowShortTitleLogo,
          title = _this$props2.title,
          isShowHelp = _this$props2.isShowHelp,
          isShowSettings = _this$props2.isShowSettings,
          onHelp = _this$props2.onHelp,
          onSettings = _this$props2.onSettings,
          isShowSolutionBar = _this$props2.isShowSolutionBar,
          onSolutionMenuButton = _this$props2.onSolutionMenuButton,
          solutionBar = _this$props2.solutionBar,
          rightContent = _this$props2.rightContent,
          burgerMenuTitle = _this$props2.burgerMenuTitle;
      var orgLogoUrl = this.state.orgLogoUrl;

      var orgLogo = function orgLogo(logoUrl, className) {
        return logoUrl ? /*#__PURE__*/React.createElement("img", {
          src: logoUrl,
          className: className || 'orgLogo-16',
          onError: function onError(e) {
            var target = e.target;
            target.onError = null;
            target.src = defaultLogoSrc;
            target.className = className === 'orgLogo-16' ? "".concat(prefix, "-header-logo") : "".concat(prefix, "-header-logo ").concat(prefix, "-header-logo-lg");
          }
        }) : undefined;
      };

      var defaultLogo = function defaultLogo(size) {
        return /*#__PURE__*/React.createElement(IconSfx, {
          size: size,
          className: size === 16 ? "".concat(prefix, "-header-logo") : "".concat(prefix, "-header-logo ").concat(prefix, "-header-logo-lg")
        });
      };

      this.throwError();
      var dom = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-header-wrap")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-header-logo-area ").concat(isShowSolutionBar ? "".concat(prefix, "-header-logo-area-fixed") : '')
      }, loggedIn ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-header-logo-min")
      }, orgLogo(logo, 'orgLogo-16') || orgLogo(orgLogoUrl, 'orgLogo-16') || defaultLogo(16)), isShowSolutionBar && /*#__PURE__*/React.createElement("span", {
        title: burgerMenuTitle || "My Solutions",
        className: "".concat(prefix, "-header-menu"),
        onClick: onSolutionMenuButton
      }, /*#__PURE__*/React.createElement(IconBurgerMenu, {
        size: 16
      }))) : orgLogo(logo, 'orgLogo-16') || orgLogo(orgLogoUrl, 'orgLogo-28') || defaultLogo(28)), loggedIn && (orgName || this.state.orgName) && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-header-orgName-name ").concat(isShowSolutionBar ? "".concat(prefix, "-header-orgName-name-fixed") : '')
      }, orgName ? orgName : this.state.orgName), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-header-title-area")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-header-title-area-md-text")
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-header-title-area-sm-text")
      }, " ", isShowShortTitleLogo && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-header-short-name-logo")
      }, orgLogo(logo, 'orgLogo-16') || orgLogo(orgLogoUrl, 'orgLogo-16') || defaultLogo(16)), /*#__PURE__*/React.createElement("span", null, "".concat(shortTitle, " ").concat(orgName ? orgName : this.state.orgName ? "| ".concat(truncate(orgName ? orgName : this.state.orgName, 14)) : '')))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-header-action-area")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-triangleBox")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-triangle")
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-header-drop-down-area")
      }, loggedIn && isShowSettings && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-header-settings-icon"),
        onClick: onSettings
      }, /*#__PURE__*/React.createElement(IconSettings, {
        size: '16'
      })), loggedIn && isShowHelp && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-header-help-icon"),
        onClick: onHelp
      }, /*#__PURE__*/React.createElement(IconHelpCircle, {
        size: '16'
      })), rightContent))), solutionBar);
      return theme ? /*#__PURE__*/React.createElement("span", {
        className: 'sfx-react-ui-theme',
        "data-theme": theme
      }, dom) : dom;
    }
  }]);

  return Header;
}(Component);

_defineProperty(Header, "defaultProps", {
  loggedIn: true,
  isShowShortTitleLogo: true,
  logo: null,
  orgName: '',
  shortTitle: '',
  title: '',
  isShowHelp: false,
  isShowSettings: false,
  isShowSolutionBar: false,
  solutionBar: null,
  rightContent: null
});

export default Header;